import { AlertFactory, AlertState } from 'alerts/Alert'
import ModalViewModel from 'infra/ModalViewModel'
import Job from 'jobs/Job'
import JobStore from 'jobs/JobStore'
import { action, computed, makeObservable, observable } from 'mobx'
import { task } from 'mobx-task'

export default class AddCouponDialogViewModel extends ModalViewModel {
  @observable couponCode = ''

  constructor(
    private getJob: () => Job,
    private jobStore: JobStore,
    private newAlert: AlertFactory,
  ) {
    super()

    makeObservable(this)

    this.close$.subscribe(this.reset)
  }

  @computed
  get job() {
    return this.getJob()
  }

  @action.bound
  reset() {
    this.couponCode = ''
    this.applyCouponAsAdmin.reset()
  }

  @action
  setCouponCode(couponCode: string) {
    this.couponCode = couponCode
  }

  applyCouponAsAdmin = task.resolved(async () => {
    const alert = this.newAlert()

    if (!this.couponCode) {
      return
    }

    try {
      await this.jobStore.callCenterApplyCouponByCode(
        this.job.id,
        this.couponCode,
      )
    } catch (error) {
      alert.fromError(error).autoDismiss().show()

      throw error
    }

    this.close()
    alert
      .saying(
        'Coupon applied!',
        `Coupon was applied to ${this.job.displayName}.`,
      )
      .withState(AlertState.Success)
      .autoDismiss()
      .show()
  })
}
